<div class="card">
    <div class="card-header" role="tab" id="headingBankAccount">
        <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Bank Account Info</h5>
            <button *ngIf="canEdit && !isEditing" class="btn btn-sm btn-primary" (click)="isEditing = true">
                <i class="fa fa-edit"></i> Change Bank Account
            </button>
        </div>
    </div>
    <div *ngIf="canEdit && isEditing" class="p-2 border-bottom">
        <div class="form-group mb-2">
            <label class="small">Select existing account or create new:</label>
            <ng-select
                [items]="bankAccounts"
                bindLabel="iban"
                bindValue="id"
                [(ngModel)]="selectedBankAccountId"
                (change)="onSelectChange($event)"
                placeholder="Select account"
                [clearable]="true"
                style="width: 100%">
                <ng-template ng-option-tmp let-item="item">
                    <div>{{ item.iban }} - {{ item.bank?.full_name || item.bank_name }}</div>
                </ng-template>
            </ng-select>
        </div>
        <div class="text-center my-2">
            <small class="text-muted">or</small>
        </div>
        <div class="form-group mb-2">
            <label class="small">Enter IBAN (format: ES70 2080 9454 2184 0364 7956):</label>
            <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="manualIban"
                (input)="onIbanInput($event)"
                placeholder="ES61 0085 3868 3824 8067 4950"
                maxlength="30">
            <small *ngIf="manualIban && !validateIban(manualIban)" class="text-danger">
                Invalid IBAN. Spanish format (ES + 22 digits)
            </small>
        </div>
        <div class="d-flex justify-content-end">
            <button *ngIf="showFurioButton" class="btn btn-sm btn-info mr-2" (click)="createFurioBankAccount()" [disabled]="isLoading">
                <i class="fa fa-plus"></i> Add Furio
            </button>
            <button class="btn btn-sm btn-secondary mr-2" (click)="cancelEdit()">
                Cancel
            </button>
            <button class="btn btn-sm btn-success" (click)="saveBankAccount()" [disabled]="isLoading">
                <i class="fa fa-save"></i> Save
            </button>
        </div>
    </div>
    <div
        id="collapseBankAccount"
        class="collapse show"
        role="tabpanel"
        aria-labelledby="headingBankAccount"
        data-parent="#accordion"
    >
        <div class="card-body">
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>IBAN</strong><span>{{ issuingPending?.bank_account?.iban }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Provider</strong><span>{{ issuingPending?.bank_account?.provider?.name }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <strong>Banco</strong><span>{{ issuingPending?.bank_account?.bank?.full_name || issuingPending?.bank_account?.bank_name }}</span>
                </li>
            </ul>
        </div>
    </div>
</div>
